type Props = {
  current: number;
  total: number;
};

const CarouselMobilePagination = (model: Props) => {
  const { total, current } = model;

  return (
    <>
      <span className="kf-o-carousel__pagination-mobile--current-page">{current}</span>
      <span className="kf-o-carousel__pagination-mobile--total">{total}</span>
    </>
  );
};

export default CarouselMobilePagination;
